module.exports = __webpack_public_path__ + "img/empty.82986da6.png";